<div class="review-bubble" *ngIf="review.review"
     [style.--l-bg-from]="review.lightBgFrom || null"
     [style.--l-bg-to]="review.lightBgTo || null"
     [style.--l-ink]="review.lightInk || null"
     [style.--l-ink-soft]="review.lightInkSoft || null"
     [style.--d-bg-from]="review.darkBgFrom || null"
     [style.--d-bg-to]="review.darkBgTo || null"
     [style.--d-ink]="review.darkInk || null"
     [style.--d-ink-soft]="review.darkInkSoft || null"
     [style.--accent]="review.accent || null">

  <div class="rb-head">
    <!-- Author: photo, name, and the rating right under the name -->
    <span class="rb-author">
      <span class="rb-avatar-wrap">
        <span class="rb-avatar">
          <img *ngIf="showAvatar" [src]="review.avatar" [alt]="review.reviewer"
               (error)="avatarFailed = true" loading="lazy" decoding="async" referrerpolicy="no-referrer">
          <span *ngIf="!showAvatar" class="rb-initial" aria-hidden="true">{{ initial }}</span>
        </span>
        <img *ngIf="review.platformLogo" class="rb-plat" [src]="review.platformLogo"
             [alt]="review.platformLabel" [title]="review.platformLabel">
      </span>
      <span class="rb-who">
        <span class="rb-name">{{ review.reviewer }}</span>
        <span class="rb-date" *ngIf="review.date">{{ review.date }}</span>
      </span>
    </span>

    <!-- The reviewed theme (pill) with the rating right-aligned beneath it -->
    <span class="rb-tags">
      <!-- a company with a long, written logo (a reference) shows that logo alone in the pill -->
      <span class="rb-pill rb-pill--wordmark" *ngIf="review.themeWordmark; else namePill" [title]="review.theme">
        <img class="rb-pill-wordmark" [src]="review.themeWordmark" [alt]="review.theme">
      </span>
      <ng-template #namePill>
      <span class="rb-pill" *ngIf="review.theme || review.themeLogo" [title]="review.theme">
        <span class="rb-pill-name" *ngIf="review.theme">{{ review.theme }}</span>
        <img *ngIf="review.themeLogo" class="rb-pill-logo" [src]="review.themeLogo"
             [alt]="review.theme">
      </span>
      </ng-template>
      <!-- role="img" is load-bearing, not decoration: aria-label is only permitted
           on elements that have a role, and a bare span's implicit role is
           generic. Without it the star rating is an invalid ARIA usage and the
           accessibility tree comes back malformed, which is what PageSpeed's
           Agentic Browsing audit fails on. The stars themselves stay
           aria-hidden, so the label is the whole accessible name. -->
      <span class="rb-stars" role="img" *ngIf="review.stars > 0"
            [attr.aria-label]="review.stars + ' out of 5 stars'">
        <svg *ngFor="let s of generateRange(review.stars)" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
        </svg>
      </span>
    </span>
  </div>

  <div class="rb-text">
    <span class="rb-text-body"><svg class="rb-quote rb-quote-open" viewBox="0 0 140 140" aria-hidden="true"><g transform="matrix(0.92465753,0,0,0.92465753,2.5,5.274)"><path d="m 113.2427,21.787569 h 24.62501 L 126.63186,72.640308 146,90.071637 130.12046,118.21243 H 74.506408 Z"/><path d="M 38.736288,21.787569 H 63.361303 L 52.125452,72.640308 71.493596,90.071637 55.614047,118.21243 H -1.383745e-7 Z"/></g></svg>{{ review.review }}<svg class="rb-quote rb-quote-close" viewBox="0 0 140 140" aria-hidden="true"><g transform="matrix(0.92465753,0,0,0.92465753,2.5,5.274)"><path d="m 113.2427,21.787569 h 24.62501 L 126.63186,72.640308 146,90.071637 130.12046,118.21243 H 74.506408 Z"/><path d="M 38.736288,21.787569 H 63.361303 L 52.125452,72.640308 71.493596,90.071637 55.614047,118.21243 H -1.383745e-7 Z"/></g></svg></span>
  </div>
</div>
